<template>
  <div class="d-flex align-center">
    <div class="d-flex align-center py-1">
      <span class="kbDarkBlueText--text mr-4" style="font-size: 14px">
        {{ `${$t('general.people')} ${$t('general.perPage')}` }}
      </span>

      <v-menu v-model="isItemsPerPageMenuOpened">
        <template v-slot:activator="{ on }">
          <div class="d-flex align-center elevation-3 white pa-2"
               style="cursor: pointer; border-radius: 6px"
               v-on="on">
                <span class="kbDark--text mr-1" style="font-size: 14px">
                  {{ pagination.itemsPerPage }}
                </span>
            <v-icon color="kbGray">{{ isItemsPerPageMenuOpened ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </div>
        </template>
        <v-list>
          <v-list-item v-for="(option, index) in itemsPerPageOptions"
                       :key="index"
                       @click="changeItemsPerPage(option)">
            <v-list-item-title>
              {{ option }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <span class="kbDarkBlueText--text ml-10"
            style="font-size: 14px">
        {{ `${1 + ((page - 1) * pagination.itemsPerPage) }-` }}
        {{ page === numberOfPages ? totalItems : page * pagination.itemsPerPage }}
        {{ $t('general.of') }}
        {{ totalItems }}
      </span>
    </div>

    <div>
      <v-pagination
        color="mainButtons"
        circle
        :length="numberOfPages"
        :total-visible="6"
        v-model="page"
      />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    numberOfPages () {
      const { itemsPerPage } = this.pagination
      if (!itemsPerPage) {
        return 1
      } else {
        return Math.ceil(this.totalItems / itemsPerPage)
      }
    },
    page: {
      get () {
        return this.pagination.page || 1
      },
      set (value) {
        const pagination = { ...this.pagination }
        pagination.page = value
        this.onPaginationChange(pagination)
      }
    }
  },
  data () {
    return {
      isItemsPerPageMenuOpened: false,
      itemsPerPageOptions: [50, 100, 200]
    }
  },
  methods: {
    changeItemsPerPage (option) {
      const pagination = { ...this.pagination }
      pagination.itemsPerPage = option
      this.onPaginationChange(pagination)
    },
    onPaginationChange (pagination) {
      this.$emit('onPaginationChange', pagination)
    }
  },
  props: {
    pagination: {
      type: Object,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    }
  }
}
</script>
